import type { UserRole } from '@/common/db-typebox';
import { env } from '@/env';
import { ApolloClient, InMemoryCache, split } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import { useMemo } from 'react';
import { createHttpApolloLink } from './http-client';
import { createWSApolloLink } from './ws-client';

// Create Apollo Client with hasuraUrl parameter
export const createApolloClient = () => {
  // Split requests between http and ws links based on operation type
  const splitLink = split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return (
        definition.kind === 'OperationDefinition' &&
        definition.operation === 'subscription'
      );
    },
    createWSApolloLink(env().VITE_HASURA_URL),
    createHttpApolloLink(env().VITE_HASURA_URL),
  );

  return new ApolloClient({
    link: splitLink,
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'cache-and-network',
      },
    },
  });
};

// For React components - uses config directly
export const useApolloClient = () => {
  return useMemo(
    () => createApolloClient(),
    [], // config is constant, no need for dependencies
  );
};

export const getAuthRoleHeader = (role: UserRole) => ({
  headers: { 'x-hasura-role': role },
});
